import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import Typography from './Typography';
import { SUBHEADLINE_TYPE, SUBHEADLINE_TYPE_MAP } from './constants';
import { defaultProps } from './types';

function Subheadline({
  children,
  type,
  ...props
}) {
  const t = SUBHEADLINE_TYPE_MAP[type];
  return /*#__PURE__*/React.createElement(Typography, _extends({}, props, {
    type: t
  }), children);
}

Subheadline.defaultProps = {
  italic: false,
  noWrap: false,
  text: '',
  type: SUBHEADLINE_TYPE.sh1
};
Subheadline.propTypes = { ...defaultProps,
  type: PropTypes.oneOf([SUBHEADLINE_TYPE.sh1, SUBHEADLINE_TYPE.sh2, SUBHEADLINE_TYPE.sh3, SUBHEADLINE_TYPE.sh4])
};
export default Subheadline;